import { reactive } from 'vue'

export const fontState = reactive({
  loaded: false,
  failed: false
})
